import React, { Component } from "react";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

class JobSeriesDeleteModal extends Component {
	constructor(props) {
		super(props);

		this.state = { deleteAll: false };
	}

	handleRadioChange = deleteAll => this.setState({ deleteAll });

	render() {
		const { lang } = global;
		const { deleteAll } = this.state;
		const {
			show,
			bulkDeleting,
			onConfirm,
			onCancel,
			flags: { jobEventAsyncDeletion },
		} = this.props;

		return (
			<Modal
				className="delete-recurring-job-modal"
				show={show}
				onExited={() => this.setState({ deleteAll: false })}
				onHide={() => onCancel()}
			>
				<Modal.Header>
					<Modal.Title>
						{bulkDeleting ? lang.t("Delete Jobs") : lang.t("Delete Job")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-sm-12">
							{bulkDeleting
								? lang.t("One or more selected jobs is part of a recurring series_")
								: lang.t("This job is part of a recurring series_")}
							&nbsp;
							{lang.t("Which instance of this job would you like to delete_")}
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12 radio">
							<label htmlFor="deleteAll_false">
								<input
									type="radio"
									name="deleteAll"
									id="deleteAll_false"
									onChange={() => this.handleRadioChange(false)}
									checked={!deleteAll}
								/>
								{lang.t(
									bulkDeleting
										? "Only the selected instances of this job"
										: "Only this job",
								)}
							</label>
						</div>
						<div className="col-sm-12 radio">
							<label htmlFor="deleteAll_true">
								<input
									type="radio"
									name="deleteAll"
									id="deleteAll_true"
									onChange={() => this.handleRadioChange(true)}
									checked={deleteAll}
								/>
								{lang.t(
									bulkDeleting
										? "All upcoming jobs in each recurring series"
										: "All upcoming jobs in this series",
								)}
							</label>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							{!!jobEventAsyncDeletion &&
								lang.t(
									"The system may take a few minutes to complete the deletion",
								)}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={() => onCancel()}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => onConfirm(deleteAll)}
					>
						{lang.t("Continue")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

JobSeriesDeleteModal.propTypes = {
	show: PropTypes.bool,
	bulkDeleting: PropTypes.bool,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	flags: PropTypes.object.isRequired,
};

JobSeriesDeleteModal.defaultProps = {
	show: false,
	bulkDeleting: false,
	onConfirm: () => {},
	onCancel: () => {},
};

export default withLDConsumer()(JobSeriesDeleteModal);
